module.exports = __webpack_public_path__ + "static/media/logo3.4230ab27.svg";